import files from './files'
import users from './users'

export default {
  files,
  users
}
